import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DeliveryNote } from '../_models/deliveryNote';
import { environment } from './../../../environments/environment';

@Injectable()
export class DeliveryNoteService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getDeliveryNotes(): Observable<DeliveryNote[]> {
    return this.http
      .get<DeliveryNote[]>(this.apiBaseUrl + 'api/private/v1/documentDeliveryNotes')
      .pipe(map((response) => response));
  }

  getDeliveryNote(id: number): Observable<DeliveryNote> {
    return this.http
      .get<DeliveryNote>(this.apiBaseUrl + 'api/private/v1/documentDeliveryNotes/' + id)
      .pipe(map((response) => response));
  }
}
